var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletAdd3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1757",
    d: "M14.501 15.3755H9.50098",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1758",
    d: "M12.001 13.0925V18.0925",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1759",
    d: "M12.2811 1.74854L12.2511 1.81854L9.35105 8.54854H6.50105C5.84137 8.54838 5.1884 8.68101 4.58105 8.93854L6.33105 4.75854L6.37105 4.65854L6.44105 4.49854C6.45828 4.43955 6.48175 4.38256 6.51105 4.32854C7.82105 1.29854 9.30105 0.608543 12.2811 1.74854Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1760",
    d: "M18.8481 8.74957C18.3908 8.61258 17.9155 8.54516 17.4381 8.54957H10.5271L13.4271 1.81957L13.4571 1.74957C13.6071 1.79957 13.7471 1.86957 13.8971 1.92957L16.1071 2.85957C17.1 3.20058 17.9955 3.77702 18.7171 4.53957C18.8127 4.65059 18.8965 4.77124 18.9671 4.89957C19.0558 5.03158 19.1233 5.17667 19.1671 5.32957C19.2044 5.41352 19.2345 5.5005 19.2571 5.58957C19.4905 6.6585 19.346 7.77529 18.8481 8.74957Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1761",
    d: "M23.0001 13.9696V15.9196C23.0001 16.1196 22.9891 16.3196 22.9771 16.5196C22.7631 20.0076 20.5661 21.7696 16.4001 21.7696H7.60008C7.33268 21.7682 7.06557 21.7515 6.80008 21.7196C3.21608 21.5096 1.30375 19.8129 1.06308 16.6296C1.02724 16.3946 1.00853 16.1573 1.00708 15.9196V13.9696C1.04127 12.9709 1.3788 12.0063 1.97474 11.2042C2.57069 10.4021 3.39678 9.80054 4.34308 9.47955C5.03542 9.22166 5.76827 9.08958 6.50708 9.08955H17.5071C18.0431 9.08846 18.5771 9.15567 19.0961 9.28955C20.1705 9.5326 21.1349 10.1226 21.8405 10.9685C22.5462 11.8143 22.9536 12.869 23.0001 13.9696Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1762",
    d: "M5.71 5.54956L3.96 9.72956C3.0818 10.1074 2.33348 10.7341 1.80745 11.5324C1.28142 12.3307 1.00072 13.2655 1 14.2216V11.2916C0.998851 9.93715 1.46778 8.62431 2.32676 7.57712C3.18574 6.52994 4.38151 5.81331 5.71 5.54956Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1763",
    d: "M22.9971 11.3725V14.3045C22.9975 13.258 22.6614 12.239 22.0384 11.3981C21.4153 10.5572 20.5384 9.93891 19.5371 9.63453C20.0277 8.65456 20.1755 7.53843 19.9571 6.46453C19.9377 6.37455 19.9075 6.28725 19.8671 6.20453C20.8117 6.69722 21.6029 7.43958 22.1548 8.35081C22.7067 9.26204 22.998 10.3072 22.9971 11.3725Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletAdd3);
export default __webpack_public_path__ + "static/media/wallet-add-3.dbf96030cd8fcdca9903b6c0662d4180.svg";
export { ForwardRef as ReactComponent };